<div class="category-success-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title style="color: #1976d2; margin: 0;">Success!</h2>
  </div>
  
  <mat-dialog-content style="padding: 20px; min-height: 80px;">
    <div style="display: flex; align-items: center; margin-bottom: 16px;">
      <mat-icon style="color: #4caf50; font-size: 48px; width: 48px; height: 48px; margin-right: 16px;">check_circle</mat-icon>
      <div style="flex: 1;">
        <p style="font-size: 16px; color: #333; margin: 0; line-height: 1.5;">
          {{ data.message }}
        </p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions style="padding: 20px; display: flex; justify-content: flex-end; gap: 12px; border-top: 1px solid #e0e0e0;">
    <button 
      mat-raised-button 
      color="accent" 
      (click)="onFinishSetup()"
      style="background-color: #6c757d; color: white; min-width: 140px;">
      Finish Setup
    </button>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onSetupReports()"
      style="background-color: #1976d2; color: white; min-width: 140px;">
      Setup Reports
    </button>
  </mat-dialog-actions>
</div>

